import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LocationOptions, LocationData } from '../../../../shared/location-picker/location-picker.component';
import { CompanyService } from '../../../../services/company-service/company.service';

@Component({
  selector: 'editLocationDialog',
  templateUrl: './editLocationDialog.component.html',
  styleUrls: ['./editLocationDialog.component.css']
})
export class EditLocationDialogComponent implements OnInit {

  locations: any[] = [];
  companyId: number;

  // Added members
  editingLocation: any = null;          // currently editing location
  newLocationAddress: string = '';      // bound to location-picker input
  showLocationPicker: boolean = false;  // controls visibility of picker
  locationPickerOptions: LocationOptions; // options for location picker
  selectedLocationData: LocationData = null;     // stores the selected location data from picker

  constructor(public dialogRef: MatDialogRef<EditLocationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private companyService: CompanyService) {
    this.locations = (this.data && this.data.locations) ? this.data.locations : [];
    this.companyId = (this.data && this.data.companyId) ? this.data.companyId : null;
    this.initializeLocationPickerOptions();
  }

  ngOnInit() {
    this.locations = (this.data && this.data.locations) ? this.data.locations : [];
    this.companyId = (this.data && this.data.companyId) ? this.data.companyId : null;
  }

  private initializeLocationPickerOptions() {
    this.locationPickerOptions = {
      title: 'Select Location',
      subtitle: 'Click on the map to select a location',
      // showLocationBelowTitle: true,
      multipleLocations: false,
      passengerMode: false,
      searchBoxText: 'Search for a location'
    };
  }

  // Show picker for adding a new location
  openLocationPicker() {
    this.editingLocation = null;
    this.newLocationAddress = '';
    this.selectedLocationData = null;
    this.showLocationPicker = true;
    
    // Reset location picker options for adding new location
    this.locationPickerOptions = {
      ...this.locationPickerOptions,
      defaultLocations: [],
      title: 'Add New Location',
      subtitle: 'Click on the map to select a location or search for one'
    };
  }

  // Show picker for editing an existing location
  editLocation(location: any) {
    this.editingLocation = location;
    this.newLocationAddress = location.address;
    this.showLocationPicker = true;
    
    // Update location picker options to show current location as a marker
    this.locationPickerOptions = {
      ...this.locationPickerOptions,
      defaultLocations: [{
        id: location.id,
        address: location.address,
        lat: location.lat,
        lng: location.lng
      }], // Show current location as a marker
      title: 'Edit Location',
      subtitle: 'Current location is marked. Click elsewhere to select a new location or search for one'
    };
  }

  // Handle location selection from the picker
  onLocationSelected(locationData: LocationData[]) {
    if (locationData && locationData.length > 0) {
      this.newLocationAddress = locationData[0].address;
      // Store the selected location data for saving
      this.selectedLocationData = locationData[0];
    }
  }

  // Save the location from picker
  saveLocation() {
    if (!this.newLocationAddress || this.newLocationAddress.trim() === '') return;

    if (this.editingLocation) {
      // update existing location with new data
      this.editingLocation.address = this.newLocationAddress.trim();
      if (this.selectedLocationData) {
        this.editingLocation.lat = this.selectedLocationData.lat;
        this.editingLocation.lng = this.selectedLocationData.lng;
      }
    } else {
      // add new location at top - don't include id for new locations
      const newLoc = {
        address: this.newLocationAddress.trim(),
        lat: this.selectedLocationData ? this.selectedLocationData.lat : null,
        lng: this.selectedLocationData ? this.selectedLocationData.lng : null
      };
      this.locations.unshift(newLoc);
    }

    // reset picker state
    this.showLocationPicker = false;
    this.newLocationAddress = '';
    this.editingLocation = null;
    this.selectedLocationData = null;
  }

  // Remove a location
  removeLocation(location: any) {
    // For locations with id, filter by id. For new locations without id, filter by reference
    if (location.id) {
      this.locations = this.locations.filter(loc => loc.id !== location.id);
    } else {
      // For new locations without id, remove by reference
      const index = this.locations.indexOf(location);
      if (index > -1) {
        this.locations.splice(index, 1);
      }
    }
    
    // If we're currently editing this location, close the picker and reset
    if (this.editingLocation && this.editingLocation === location) {
      this.showLocationPicker = false;
      this.editingLocation = null;
      this.newLocationAddress = '';
      this.selectedLocationData = null;
    }
  }

  // Save all changes and close dialog
  saveAllChanges() {
    const body = {
      id: this.companyId,
      locations: this.locations
    };

    this.companyService.updateCompanyLocations(body).then((res: any) => {
      if (res.status) {
        this.dialogRef.close(this.locations);
      } else {
        alert(res.message || "Unable to update locations");
      }
    }).catch(e => {
      alert("Unable to update locations: " + e);
    });
  }

  // Cancel and close dialog
  cancel() {
    this.dialogRef.close();
  }

  // Cancel location picker and reset state
  cancelLocationPicker() {
    this.showLocationPicker = false;
    this.editingLocation = null;
    this.newLocationAddress = '';
    this.selectedLocationData = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/utilities/Dialog/dialog/edit-location-dialog/editLocationDialog.component.ts